import React from "react";
import {
  Modal,
  Box,
  Paper,
  Typography,
  Button,
} from "@mui/material";
import ErrorIcon from "@mui/icons-material/Error";

const ModalErrorFacturacion = ({ open, onClose, error, mensajeFacturacion = "" }) => {
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: { xs: "90%", sm: 400 },
          maxWidth: 500,
        }}
      >
        <Paper
          elevation={5}
          sx={{
            p: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <ErrorIcon sx={{ fontSize: 64, color: "#e74c3c" }} />
          <Typography variant="h6" fontWeight="bold" textAlign="center">
            ⚠️ Error en la facturación
          </Typography>
          <Typography textAlign="center" color="text.secondary">
            {error ||
              "Ocurrió un problema al generar la factura. Intente nuevamente."}
          </Typography>
          {mensajeFacturacion !== ""?
          <Typography textAlign="center" color="text.secondary">
            {mensajeFacturacion}
          </Typography>
          :null}
          <Button
            variant="contained"
            color="error"
            onClick={onClose}
            sx={{ mt: 1, px: 4 }}
          >
            Salir
          </Button>
        </Paper>
      </Box>
    </Modal>
  );
};

export default ModalErrorFacturacion;